import * as Sentry from "@sentry/browser";

export const sendError = (error: string | Error, level: 'error' | 'warning' | 'info' | 'debug' = 'error') => {
    if (error instanceof Error) {
        Sentry.captureException(error);
    } else {
        Sentry.captureMessage(error, level);
    }
};